import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { services } from "@/data/press";

const fade = {
  hidden: { opacity: 0, y: 30 },
  visible: (i) => ({ opacity: 1, y: 0, transition: { duration: 0.7, ease: [0.22, 1, 0.36, 1], delay: i * 0.08 } }),
};

export const Services = () => {
  return (
    <section id="services" data-testid="services-section" className="bg-ivory py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-6">
        <div className="max-w-3xl mb-16 sm:mb-24">
          <p className="overline text-gold-dark mb-6">What we do</p>
          <h2 className="font-serif font-light text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[1.05]">
            Four disciplines, one standard of judgment.
          </h2>
          <p className="text-navy/60 text-base sm:text-lg leading-relaxed mt-6 max-w-2xl">
            A strategic communications agency and crisis PR firm — from crisis management help in the first hour to
            long-term reputation advisory. If you need to hire a crisis communications consultant, this is where it
            starts.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 border-t border-l border-navy/15">
          {services.map((s, i) => (
            <motion.div
              key={s.no}
              custom={i}
              variants={fade}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, margin: "-80px" }}
              data-testid={`service-card-${s.no}`}
              className="group relative border-b border-r border-navy/15 p-8 sm:p-12 hover:bg-navy transition-colors duration-500"
            >
              <div className="flex items-start justify-between mb-10">
                <span className="font-serif text-2xl text-gold-dark group-hover:text-gold transition-colors">{s.no}</span>
                <span className="text-navy/30 group-hover:text-gold transition-all group-hover:translate-x-1 group-hover:-translate-y-1">&#8599;</span>
              </div>
              <h3 className="font-serif text-3xl sm:text-4xl font-light mb-5 group-hover:text-ivory transition-colors">
                {s.title}
              </h3>
              <p className="text-navy/65 group-hover:text-ivory/70 transition-colors leading-relaxed max-w-md">
                {s.desc}
              </p>
            </motion.div>
          ))}
        </div>

        <div className="mt-12 flex flex-col sm:flex-row sm:items-center gap-5">
          <Link
            to="/services"
            data-testid="services-explore-link"
            className="group inline-flex items-center gap-3 bg-navy hover:bg-navy-700 text-ivory px-8 py-4 overline transition-colors"
          >
            Explore all services <span className="transition-transform group-hover:translate-x-1">&rarr;</span>
          </Link>
          <a href="#contact" data-testid="services-section-contact" className="overline text-navy/60 hover:text-navy transition-colors">
            or start a conversation
          </a>
        </div>
      </div>
    </section>
  );
};
